// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
function gm_authFailure() {
  // Editor check
  const isThemeEditor = window.Shopify && window.Shopify.designMode;
  if (!isThemeEditor) return;

  const maps = document.querySelectorAll('[data-map-container]');
  const javascriptApi = 'https://developers.google.com/maps/documentation/javascript/get-api-key';
  const geocodingApi = 'https://developers.google.com/maps/documentation/geocoding/get-api-key';
  const errorMessage = `
    <p>
      The API key you entered is invalid. To activate your map:
      <ol>
        <li>
          Generate both <a href="${javascriptApi}" target="_blank">JavaScript</a>
          and <a href="${geocodingApi}" target="_blank">Geocoding</a> API keys.
        </li>
        <li>Copy and paste one of them into the theme editor.</li>
        <li>Save your changes to verify the new API key.</li>
      </ol>
    </p>
  `;

  maps.forEach((map) => {
    map.innerHTML = `<div class="map-error-message">${errorMessage}</div>`;
  });
}

window.gm_authFailure = gm_authFailure;
